import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { Router, useNavigate, Navigate } from "react-router-dom";

// JS Files
import { CustomerBasketProvider } from "../../../context/CustomerBasketContext";

// Routes
import CreateOrder from "../create-order/CreateOrder.js";
import PreOrders from "../orders/pre-orders/PreOrders.js";
import NewOrders from "../orders/new-orders/NewOrders.js";
import CurrentOrders from "../orders/current-orders/CurrentOrders.js";
import ReceviedOrders from "../orders/recevied-order/ReceviedOrders.js";
import CanceledOrders from "../orders/canceled-orders/CanceledOrders.js";
import CustomerSetParameter from "../setting/parameter/CustomerSetParameter";
import CustomerMessages from "../messages/CustomerMessages";
import Chats from "../chats/Chats";
import ReturnedOrder from "../returned-order/ReturedOrder";
import ReturnedOrderList from "../returned-order/order-list/ReturnedOrderList";
import PrintOrders from "../orders/PrintOrders";
import PrintOrderDetails from "../orders/PrintOrderDetails";
import Employee from "../setting/employee/Employee";
import PrintPreOrder from "../orders/pre-orders/PrintPreOrder";
import CurrentOrdersTabs from "../orders/current-orders/CurrentOrdersTabs";
import PrintGeneralOrderByBangle from '../orders/current-orders/PrintGeneralOrderByBangle';
import CustomerPrintOrderDetailsByBangle from '../orders/current-orders/CustomerPrintOrderDetailsByBangle';

const CustomerRoutes = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/create-order" />} />
        <Route path="/pre-orders" element={<PreOrders />} />
        <Route path="/new-orders" element={<NewOrders />} />
        <Route
          path="/print-new-orders/:order_type/:unique_id/:date"
          element={<PrintOrders />}
        />
        {/* <Route path="/print-new-orders-detail" element={<NewOrders />} /> */}
        <Route path="/current-orders" element={<CurrentOrdersTabs />} />
        <Route
          path="/print-current-orders-by-bangle/:unique_id/:bangle_name/:brand/:status/:zero_status"
          element={<PrintGeneralOrderByBangle />}
        />
          <Route
          path="/customer-print-report-details-by-bangle/:id"
          element={<CustomerPrintOrderDetailsByBangle />}
        />

        <Route
          path="/print-current-orders/:order_type/:unique_id/"
          element={<PrintOrders />}
        />

        <Route path="/recevied-orders" element={<ReceviedOrders />} />
        <Route
          path="/print-recevied-orders/:order_type/:unique_id/:date"
          element={<PrintOrders />}
        />

        <Route path="/cancelled-orders" element={<CanceledOrders />} />
        <Route
          path="/print-cancelled-orders/:order_type/:unique_id/:date"
          element={<PrintOrders />}
        />
        <Route
          path="/print-order-details/:id"
          element={<PrintOrderDetails />}
        />
         <Route
          path="/print-pre-orders/:unique_id/:date"
          element={<PrintPreOrder />}
        />
        {/* <Route path="/set-parameter" element={<Parameterrr />} /> */}
        <Route
          path="/create-order"
          element={
            <CustomerBasketProvider>
              <CreateOrder />
            </CustomerBasketProvider>
          }
        />
        <Route path="/returned-order" element={<ReturnedOrder />} />
        <Route path="/returned-order-list" element={<ReturnedOrderList />} />

        <Route
          path="/setting-set-parameter"
          element={<CustomerSetParameter />}
        />
        <Route path="/setting-employee" element={<Employee />} />
        {/*..................Chats................... */}
        <Route path="/chats" element={<Chats />} />
        <Route path="/messages" element={<CustomerMessages />} />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
};
export default CustomerRoutes;
